import React from 'react';
import { Button, Text, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  grid: {
    width: '100%',
    overflowX: 'auto',
  },
  gridContent: {
    minWidth: '760px',
  },
  empty: {
    padding: '48px',
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    marginTop: '16px',
  },
  paginationActions: {
    display: 'flex',
    gap: '8px',
  },
  total: {
    color: tokens.colorNeutralForeground3,
  },
});

interface AdminDataGridProps extends React.PropsWithChildren {
  minWidth?: string;
}

export const AdminDataGrid: React.FC<AdminDataGridProps> = ({ children, minWidth = '760px' }) => {
  const styles = useStyles();

  return (
    <div className={styles.grid}>
      <div className={styles.gridContent} style={{ minWidth }}>{children}</div>
    </div>
  );
};

export const AdminDataGridEmpty: React.FC<React.PropsWithChildren> = ({ children }) => {
  const styles = useStyles();
  return <div className={styles.empty}>{children}</div>;
};

interface AdminPaginationProps {
  totalLabel: string;
  page: number;
  pageSize: number;
  total: number;
  loading?: boolean;
  onPageChange: (page: number) => void;
}

export const AdminPagination: React.FC<AdminPaginationProps> = ({
  totalLabel,
  page,
  pageSize,
  total,
  loading = false,
  onPageChange,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.pagination}>
      <Text className={styles.total}>{totalLabel}</Text>
      <div className={styles.paginationActions}>
        <Button
          appearance="subtle"
          disabled={loading || page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </Button>
        <Button
          appearance="subtle"
          disabled={loading || page * pageSize >= total}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};